import { Button } from "@mui/material";
import { ArrowDropUp as ArrowDropUpIcon, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

import "./style.less";

export type TSortArrowSelect = "none" | "up" | "down";

interface ISortArrows {
	select?: TSortArrowSelect;
	onClick?: (type: TSortArrowSelect) => void;
}

export default function SortArrows({
	select = "none",
	onClick = () => {},
}: ISortArrows) {
	function btnClick(type: TSortArrowSelect) {
		if ((type === "up" && select !== "up") || (type === "down" && select !== "down")) {
			onClick(type);
		} else {
			onClick("none");
		}
	}

	return <span className="sortArrows">
		<Button className="sortArrows__upBtn" onClick={() => btnClick("up")}>
			<ArrowDropUpIcon sx={{ fill: select === "up" ? "--dark-green-text-color" : "#000" }} />
		</Button>
		<Button className="sortArrows__downBtn" onClick={() => btnClick("down")}>
			<ArrowDropDownIcon sx={{ fill: select === "down" ? "--dark-green-text-color" : "#000" }} />
		</Button>
	</span>;
}
